var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._m(0),_c('div',{staticClass:"errorBottomBtn",on:{"click":_vm.backBtn}},[_vm._v("확인")])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"errorWrap"},[_c('div',{staticClass:"errorImg"}),_c('p',{staticClass:"errorText"},[_vm._v(" 로그인 시간이 만료되었습니다."),_c('br'),_c('span',[_vm._v("다시 로그인 해주세요.")])])])
}]

export { render, staticRenderFns }